import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-bold text-lg mb-2" }
const _hoisted_2 = { class: "text-gray-600 text-sm mb-4" }
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = ["href"]

import { computed } from "vue";
import Button from "primevue/button";
import type { NewsItem } from "../types";


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkPreview',
  props: {
    newsItem: {},
    selected: { type: Boolean }
  },
  emits: ["toggle-selection"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const cleanText = (text: string) => {
  return text
    .replace(/<\/?b>/g, "")
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .trim();
};

const cleanTitle = computed(() => cleanText(props.newsItem.title));
const cleanDescription = computed(() => cleanText(props.newsItem.description));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["border rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 p-4", {
      'border-primary-500': props.selected,
      'border-gray-200': !props.selected,
    }])
  }, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(cleanTitle.value), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(cleanDescription.value), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        href: props.newsItem.link,
        target: "_blank",
        rel: "noopener noreferrer",
        class: "text-primary-600 hover:text-primary-800 transition-colors duration-300"
      }, " 자세히 보기 ", 8, _hoisted_4),
      _createVNode(_unref(Button), {
        icon: props.selected ? 'pi pi-check-square' : 'pi pi-square',
        class: _normalizeClass({ 'p-button-outlined': !props.selected }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-selection', props.newsItem)))
      }, null, 8, ["icon", "class"])
    ])
  ], 2))
}
}

})